import * as Yup from 'yup';

export const segregationValidationSchema = Yup.object({
  segregation: Yup.string().required('Segregation is required'),
});
